
export default () => ({
    valid: false,
})
